import React, {useEffect, useState} from "react";
import {Link, useLocation} from "react-router-dom";
import {super_admin_role_id, admin_role_id, next_app} from "../../constant";
import { navigateToNextWithSync, getLogoutUrl } from "../../utils/syncUtils";

const DashboardSidebar = ({isOpen, toggleSidebar}) => {
	const location = useLocation();
	const logout = () => {
		localStorage.removeItem("auth_token");
		localStorage.removeItem("is_login");
		localStorage.removeItem("first_name");
		localStorage.removeItem("last_name");
		localStorage.removeItem("reviewsData");
		localStorage.removeItem("reviews_addresses_id");
		localStorage.removeItem("role");
		localStorage.removeItem("searchedAddress");
		localStorage.removeItem("verified");
		localStorage.removeItem("badge");
		window.location.href = getLogoutUrl();
	};

	// const firstName = localStorage.getItem("first_name") || "";
	// const lastName = localStorage.getItem("last_name") || "";

	const [firstName, setFirstName] = useState("");
	const [lastName, setLastName] = useState("");

	useEffect(() => {
		const loadUserData = () => {
			setFirstName(localStorage.getItem("first_name") || "");
			setLastName(localStorage.getItem("last_name") || "");
		};

		// Load initial data
		loadUserData();

		// Listen for localStorage changes
		const handleStorageChange = (e) => {
			if (e.key === "first_name" || e.key === "last_name") {
				loadUserData();
			}
		};

		// Listen for custom events (for same-tab updates)
		const handleCustomStorageChange = () => {
			loadUserData();
		};

		window.addEventListener("storage", handleStorageChange);
		window.addEventListener("localStorageUpdate", handleCustomStorageChange);

		return () => {
			window.removeEventListener("storage", handleStorageChange);
			window.removeEventListener("localStorageUpdate", handleCustomStorageChange);
		};
	}, []);

	const userRole = localStorage.getItem("role") == super_admin_role_id ? "Super Admin" : localStorage.getItem("role") == admin_role_id ? "Admin" : "Contractor";

	// Get initials for avatar
	const getInitials = () => {
		if (firstName && lastName) {
			return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
		} else if (firstName) {
			return firstName.charAt(0).toUpperCase();
		}
		return "U";
	};

	const menuItems = [
		{
			path: "/admin-dashboard",
			icon: (
				<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z"
						stroke="currentColor"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>
			),
			label: "Dashboard",
			exact: true,
		},
		{
			path: "/admin-dashboard/admin",
			icon: (
				<svg width="22" height="22" viewBox="0 0 24 24" fill="none">
					<rect width="24" height="24" fill="none" />
					<path fill="currentColor" d="M12 23C6.443 21.765 2 16.522 2 11V5l10-4l10 4v6c0 5.524-4.443 10.765-10 12M4 6v5a10.58 10.58 0 0 0 8 10a10.58 10.58 0 0 0 8-10V6l-8-3Z" />
					<circle cx="12" cy="8.5" r="2.5" fill="currentColor" />
					<path fill="currentColor" d="M7 15a5.78 5.78 0 0 0 5 3a5.78 5.78 0 0 0 5-3c-.025-1.896-3.342-3-5-3c-1.667 0-4.975 1.104-5 3" />
				</svg>
			),
			label: "Admins",
			exact: true,
			for_role: super_admin_role_id,
		},
		{
			path: "/admin-dashboard/contractor",
			icon: (
				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
					<path
						fill="none"
						stroke="currentColor"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
						d="M18 18.72a9.1 9.1 0 0 0 3.741-.479q.01-.12.01-.241a3 3 0 0 0-4.692-2.478m.94 3.197l.001.031q0 .337-.037.666A11.94 11.94 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6 6 0 0 1 6 18.719m12 0a5.97 5.97 0 0 0-.941-3.197m0 0A6 6 0 0 0 12 12.75a6 6 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72a9 9 0 0 0 3.74.477m.94-3.197a5.97 5.97 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0a3 3 0 0 1 6 0m6 3a2.25 2.25 0 1 1-4.5 0a2.25 2.25 0 0 1 4.5 0m-13.5 0a2.25 2.25 0 1 1-4.5 0a2.25 2.25 0 0 1 4.5 0"
					/>
				</svg>
			),
			label: "Contractors",
			exact: true,
		},

		{
			path: "/admin-dashboard/manual-address",
			icon: (
				<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
					<path
						d="m19.799 5.165l-2.375-1.83a2 2 0 0 0-.521-.237A2 2 0 0 0 16.336 3H9.5l.801 5h6.035c.164 0 .369-.037.566-.098s.387-.145.521-.236l2.375-1.832c.135-.091.202-.212.202-.334s-.067-.243-.201-.335M8.5 1h-1a.5.5 0 0 0-.5.5V5H3.664c-.166 0-.37.037-.567.099c-.198.06-.387.143-.521.236L.201 7.165C.066 7.256 0 7.378 0 7.5c0 .121.066.242.201.335l2.375 1.832c.134.091.323.175.521.235c.197.061.401.098.567.098H7v8.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-17a.5.5 0 0 0-.5-.5"
						fill="currentColor"
						stroke="currentColor"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>
			),
			label: "Manual Address",
		},
		{
			path: "/admin-dashboard/address",
			icon: (
				<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24">
					<path
						fill="currentColor"
						d="M12 6.5A2.5 2.5 0 0 1 14.5 9a2.5 2.5 0 0 1-2.5 2.5A2.5 2.5 0 0 1 9.5 9A2.5 2.5 0 0 1 12 6.5M12 2a7 7 0 0 1 7 7c0 5.25-7 13-7 13S5 14.25 5 9a7 7 0 0 1 7-7m0 2a5 5 0 0 0-5 5c0 1 0 3 5 9.71C17 12 17 10 17 9a5 5 0 0 0-5-5"
					/>
				</svg>
			),
			label: "Addresses",
		},
		{
			path: "/admin-dashboard/ratings",
			icon: (
				<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
				</svg>
			),
			label: "Ratings",
		},

		{
			path: "/admin-dashboard/comments",
			icon: (
				<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" stroke="currentColor" strokeWidth="2" />
				</svg>
			),
			label: "Comments",
		},
		{
			path: "/admin-dashboard/replies",
			icon: (
				<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16">
					<rect width="16" height="16" fill="none" />
					<path
						fill="currentColor"
						d="M1.75 1h8.5c.966 0 1.75.784 1.75 1.75v5.5A1.75 1.75 0 0 1 10.25 10H7.061l-2.574 2.573A1.458 1.458 0 0 1 2 11.543V10h-.25A1.75 1.75 0 0 1 0 8.25v-5.5C0 1.784.784 1 1.75 1M1.5 2.75v5.5c0 .138.112.25.25.25h1a.75.75 0 0 1 .75.75v2.19l2.72-2.72a.75.75 0 0 1 .53-.22h3.5a.25.25 0 0 0 .25-.25v-5.5a.25.25 0 0 0-.25-.25h-8.5a.25.25 0 0 0-.25.25m13 2a.25.25 0 0 0-.25-.25h-.5a.75.75 0 0 1 0-1.5h.5c.966 0 1.75.784 1.75 1.75v5.5A1.75 1.75 0 0 1 14.25 12H14v1.543a1.458 1.458 0 0 1-2.487 1.03L9.22 12.28a.749.749 0 0 1 .326-1.275a.75.75 0 0 1 .734.215l2.22 2.22v-2.19a.75.75 0 0 1 .75-.75h1a.25.25 0 0 0 .25-.25Z"
					/>
				</svg>
			),
			label: "Replies",
		},
		{
			path: "/admin-dashboard/notifications",
			icon: (
				<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						d="M18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z"
						stroke="currentColor"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M13.73 21C13.5542 21.3031 13.3019 21.5547 12.9982 21.7295C12.6946 21.9044 12.3504 21.9965 12 21.9965C11.6496 21.9965 11.3054 21.9044 11.0018 21.7295C10.6982 21.5547 10.4458 21.3031 10.27 21"
						stroke="currentColor"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>
			),
			label: "Notifications",
		},
		{
			path: "/admin-dashboard/feedback",
			icon: (
				<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						d="M21 15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H7L3 21V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V15Z"
						stroke="currentColor"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>
			),
			label: "User Feedback",
		},
		{
			path: "/admin-dashboard/contact-us",
			icon: (
				<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						d="M3 8L10.89 13.26C11.2187 13.4793 11.6049 13.5963 12 13.5963C12.3951 13.5963 12.7813 13.4793 13.11 13.26L21 8M5 19H19C19.5304 19 20.0391 18.7893 20.4142 18.4142C20.7893 18.0391 21 17.5304 21 17V7C21 6.46957 20.7893 5.96086 20.4142 5.58579C20.0391 5.21071 19.5304 5 19 5H5C4.46957 5 3.96086 5.21071 3.58579 5.58579C3.21071 5.96086 3 6.46957 3 7V17C3 17.5304 3.21071 18.0391 3.58579 18.4142C3.96086 18.7893 4.46957 19 5 19Z"
						stroke="currentColor"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>
			),
			label: "Visitor Feedback",
		},
		{
			path: "/admin-dashboard/reports",
			icon: (
				<svg xmlns="http://www.w3.org/2000/svg" width="1.2em" height="1.2em" viewBox="0 0 48 48">
					<rect width="48" height="48" fill="none" />
					<g fill="none" stroke="currentColor" stroke-linejoin="round" stroke-width="4">
						<path d="M5 7a3 3 0 0 1 3-3h24a3 3 0 0 1 3 3v37H8a3 3 0 0 1-3-3zm30 17a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v17a3 3 0 0 1-3 3h-5z" />
						<path stroke-linecap="round" d="M11 12h8m-8 7h12" />
					</g>
				</svg>
			),
			label: "Reports",
		},
		{
			path: "/admin-dashboard/users/delete",
			icon: (
				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
					<path
						fill="none"
						stroke="currentColor"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
						d="M18 18.72a9.1 9.1 0 0 0 3.741-.479q.01-.12.01-.241a3 3 0 0 0-4.692-2.478m.94 3.197l.001.031q0 .337-.037.666A11.94 11.94 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6 6 0 0 1 6 18.719m12 0a5.97 5.97 0 0 0-.941-3.197m0 0A6 6 0 0 0 12 12.75a6 6 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72a9 9 0 0 0 3.74.477m.94-3.197a5.97 5.97 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0a3 3 0 0 1 6 0m6 3a2.25 2.25 0 1 1-4.5 0a2.25 2.25 0 0 1 4.5 0m-13.5 0a2.25 2.25 0 1 1-4.5 0a2.25 2.25 0 0 1 4.5 0"
					/>
				</svg>
			),
			label: "Deactivated Users",
		},
		{
			path: "/admin-dashboard/login-history",
			icon: (
				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
					<g fill="none">
						<path stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l2.5 2.5" />
						<path
							fill="currentColor"
							d="m5.604 5.604l-.53-.53zM4.338 6.871l-.75.003a.75.75 0 0 0 .746.747zm2.542.762a.75.75 0 1 0 .007-1.5zM5.075 4.321a.75.75 0 0 0-1.5.008zM3.75 12a.75.75 0 0 0-1.5 0zm13.125 8.445a.75.75 0 1 0-.75-1.298zm2.272-4.32a.75.75 0 1 0 1.298.75zM5.14 5.07a.75.75 0 1 0 1.056 1.066zm13.722.067c-3.82-3.82-9.993-3.859-13.788-.064l1.06 1.06c3.2-3.199 8.423-3.18 11.668.065zM5.074 5.074L3.808 6.34l1.06 1.06l1.267-1.265zm-.74 2.547l2.546.012l.007-1.5l-2.545-.012zm.754-.754L5.075 4.32l-1.5.008l.013 2.545zM12 3.75A8.25 8.25 0 0 1 20.25 12h1.5A9.75 9.75 0 0 0 12 2.25zm0 16.5A8.25 8.25 0 0 1 3.75 12h-1.5A9.75 9.75 0 0 0 12 21.75zm4.125-1.103A8.2 8.2 0 0 1 12 20.25v1.5c1.775 0 3.44-.475 4.875-1.305zM20.25 12a8.2 8.2 0 0 1-1.103 4.125l1.298.75A9.7 9.7 0 0 0 21.75 12zM6.196 6.137A8.22 8.22 0 0 1 12 3.75v-1.5a9.72 9.72 0 0 0-6.86 2.821z"
						/>
					</g>
				</svg>
			),
			label: "Login History",
			for_role: super_admin_role_id,
		},
		{
			path: "/admin-dashboard/activity-log",
			icon: (
				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
					<path
						fill="currentColor"
						d="M14.33 20h-.21a2 2 0 0 1-1.76-1.58L9.68 6l-2.76 6.4A1 1 0 0 1 6 13H3a1 1 0 0 1 0-2h2.34l2.51-5.79a2 2 0 0 1 3.79.38L14.32 18l2.76-6.38A1 1 0 0 1 18 11h3a1 1 0 0 1 0 2h-2.34l-2.51 5.79A2 2 0 0 1 14.33 20"
					/>
				</svg>
			),
			label: "Activity Logs",
		},
	];

	const isActiveRoute = (path, exact = false) => {
		if (exact) {
			return location.pathname === path;
		}
		return location.pathname.startsWith(path);
	};

	const verification = localStorage.getItem("verified");
	const badge = localStorage.getItem("badge");

	return (
		<>
			{/* Mobile Overlay */}
			{isOpen && <div className="dashboard-sidebar-overlay" onClick={toggleSidebar} />}

			{/* Sidebar */}
			<div className={`dashboard-sidebar ${isOpen ? "open" : ""}`}>
				<div className="sidebar-header">
					<a 
						href="/" 
						className="sidebar-logo"
						onClick={(e) => {
							e.preventDefault();
							navigateToNextWithSync("/");
						}}
					>
						<img src={`${process.env.PUBLIC_URL}/img/header-logo.png`} alt="JobSiteRating" className="sidebar-logo-img" />
					</a>
					<button className="sidebar-close-btn d-lg-none" onClick={toggleSidebar}>
						<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
							<path d="M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
						</svg>
					</button>
				</div>

				<nav className="sidebar-nav">
					<ul className="nav-list">
						{/* {menuItems.map((item, index) => (
							<>
							{item?.for_role && item.for_role == localStorage.getItem("role")&&
							 }

							{item?.for_role && item.for_role == localStorage.getItem("role")&&

							
							<li key={index} className="nav-item">
								<Link to={item.path} className={`nav-link ${isActiveRoute(item.path, item.exact) ? "active" : ""}`} onClick={() => window.innerWidth < 992 && toggleSidebar()}>
									<span className="nav-icon">{item.icon}</span>
									<span className="nav-label">{item.label}</span>
								</Link>
							</li>
							}
							</>
						))} */}
						{menuItems
							.filter((item) => !item?.for_role || item.for_role === localStorage.getItem("role"))
							.map((item, index) => (
								<li key={index} className="nav-item">
									<Link to={item.path} className={`nav-link ${isActiveRoute(item.path, item.exact) ? "active" : ""}`} onClick={() => window.innerWidth < 992 && toggleSidebar()}>
										<span className="nav-icon">{item.icon}</span>
										<span className="nav-label">{item.label}</span>
									</Link>
								</li>
							))}
					</ul>
				</nav>

				<div className="sidebar-footer">
					{/* <Link to="/admin-dashboard/my-profile" className="user-info mb-3 text-decoration-none"> */}
					{/* <Link className="user-info mb-3 text-decoration-none">
						
						<div className="user-avatar position-relative">
							<span>{getInitials()}</span>
							{verification === "true" && (
								<svg
									className="position-absolute"
									style={{
										top: "-8px",
										right: "-9px",
										background: "#FFF",
										borderRadius: "100px",
									}}
									xmlns="http://www.w3.org/2000/svg"
									width="18"
									height="18"
									viewBox="0 0 24 24">
									<path
										// fill="#ffc107"
										fill="#0d6efd"
										d="M10.95 12.7L9.5 11.275Q9.225 11 8.813 11t-.713.3q-.275.275-.275.7t.275.7l2.15 2.15q.3.3.7.3t.7-.3l4.25-4.25q.3-.3.287-.7t-.287-.7q-.3-.3-.712-.312t-.713.287zm-2.8 9.05L6.7 19.3l-2.75-.6q-.375-.075-.6-.387t-.175-.688L3.45 14.8l-1.875-2.15q-.25-.275-.25-.65t.25-.65L3.45 9.2l-.275-2.825q-.05-.375.175-.688t.6-.387l2.75-.6l1.45-2.45q.2-.325.55-.438t.7.038l2.6 1.1l2.6-1.1q.35-.15.7-.038t.55.438L17.3 4.7l2.75.6q.375.075.6.388t.175.687L20.55 9.2l1.875 2.15q.25.275.25.65t-.25.65L20.55 14.8l.275 2.825q.05.375-.175.688t-.6.387l-2.75.6l-1.45 2.45q-.2.325-.55.438t-.7-.038l-2.6-1.1l-2.6 1.1q-.35.15-.7.038t-.55-.438"
									/>
								</svg>
							)}

							{badge == "true" && (
								<div
									className="position-absolute"
									style={{
										top: "16px",
										right: "35px",
										background: "#FFF",
										borderRadius: "100px",
									}}>
									<img src={`${process.env.PUBLIC_URL}/img/favicon.png`} width={20} />
								</div>
							)}
						</div>

						<div className="user-details">
							<div className="user-name text-capitalize">
								{firstName} {lastName}
							</div>
							<div className="user-role text-capitalize">{userRole}</div>
						</div>
						
					</Link> */}
					<button className="logout-btn" onClick={logout}>
						<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9"
								stroke="currentColor"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<path d="M16 17L21 12L16 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
							<path d="M21 12H9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
						</svg>
						Logout
					</button>
				</div>
			</div>
		</>
	);
};

export default DashboardSidebar;
